import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/lib/utils';

/**
 * The Customers, Suppliers & CRM sub-navigation (PART 10 §10.1's menu group):
 * Customers / Suppliers (MD-01 — the group's first child), Leads (CRM-01),
 * Opportunities / Pipeline (CRM-02), Follow-ups (CRM-03). The statement
 * (CRM-04) lives inside the partner detail.
 */
const TABS = [
  { to: '/partners', end: true, key: 'crm.tabPartners' },
  { to: '/partners/leads', end: false, key: 'crm.tabLeads' },
  { to: '/partners/opportunities', end: false, key: 'crm.tabOpportunities' },
  { to: '/partners/followups', end: false, key: 'crm.tabFollowups' },
] as const;

export function CrmTabs() {
  const { t } = useTranslation();
  return (
    <nav className="flex flex-wrap gap-1 border-b pb-px" aria-label={t('shell.navPartners')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'rounded-t-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground',
              isActive && 'border-b-2 border-primary text-foreground',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
